import { render } from "./App.vue?vue&type=template&id=1c0a8c49"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1c0a8c49&lang=scss"
import "./App.vue?vue&type=style&index=1&id=1c0a8c49&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__